<template>
<modal name="recordErrorTip"
      transition="nice-modal-fade"
      :pivotY="0.3"
      @before-open="recordErrorOpen"
    >
  <div class="record-error">
    <div class="title">
      <span>录音设备异常提示</span>
      <div class="close-button" @click="close">
        <i></i>
      </div>
    </div>
    <div class="content">
      <div>
        检测到您当前的麦克风设备异常,无法进行录音.还请调试好录音设备后重试.
      </div>
      <div>
        以下可能引发异常情况供您参考:
      </div>
      <div>{{error}}</div>
    </div>
    <div class="button-content">
      <el-button type="primary" @click="close">知道了</el-button>
    </div>
  </div>
  </modal>
</template>

<script>
export default {
  name: 'recordError',
  data () {
    return {
      type: '',
      error: '请确保支持录音',
      advice: '还请修复此问题后重试',
    }
  },
  mounted () {
  },
  methods: {
    recordErrorOpen(e) {
      this.type = e.params.type;
      if(this.type === 'NotAllowedError') {
        this.error = '您的浏览器未开启录音，无法支持录音。';
      } else if(this.type === 'noFunction') {
        this.error = '当前浏览器不支持录音，我们建议您下载最新版的谷歌浏览器以更好地支持录音。'
      } else if(this.type === 'NotFoundError') {
        this.error = '您未连接麦克风设备，无法支持录音。';
      }
    },
    close () {
      this.$modal.hide('recordErrorTip');
    }
  }
}
</script>

<style lang="scss" scoped>
.record-error {
  position: relative;
  width: 525px;
  height: 235px;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 0 15px;
  height: 28px;
  background-color: #d8dee9;
  color: #474261;
}
div.close-button {
  position: absolute;
  right: 10px;
  top: 5px;
  width: 16px;
  cursor: pointer;
}
i {
  position:relative;
  left: 7px;
  top: 2px;
  width: 2px;
  height: 15px;
  border-radius: 3px;
  background: #737596;
  transform: rotate(45deg);
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 15px;
    border-radius: 3px;
    background: #737596;
    transform: rotate(270deg);
  }
}
.content {
  color: #666;
  font-size: 13px;
  margin: 25px;
  div {
    line-height: 2.5;
  }
}
.button-content {
  text-align: center;

  button {
    height: 36px;
    padding: 10px 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/record/errorTip.vue